<template>
  <div class="blob green"></div>
</template>

<script>
export default {
  name: 'SpeakingIndicator'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/display/SpeakingIndicator.vue